import React from "react";
import styled, { css } from "styled-components";

import flags from "../data/flags.json";

const Preview = ({ mode, preview }) => {
    const iso = flags[preview.currentCountry]; 

    return <Container 
        mode={ mode } 
        isDisplayed={ !!preview.currentCountry } 
        position={ preview.position }>
        <CountryName style={{ textTransform: "capitalize" }}>
            { preview.currentCountry 
                ? <img 
                    src={ require(`../assets/flags/${ iso }.png`) }
                    alt={ `${ preview.currentCountry } flag` } /> 
                : null  }
            <span>{ preview.currentCountry }</span>
        </CountryName>
        <p>✅ {new Intl.NumberFormat('en').format(preview.contributions)}</p>
    </Container>
}

const Container = styled.div`
    position: absolute;
    left: 50%;
    top: 20px;
    border-radius: 5px;
    transform: translateX(-50%);
    z-index: 1000;
    padding: 12px 24px;
    font-size: 18px;

    ${ props => props.position && css`
        top: ${ props.position.y + 20 }px;
        left: ${ props.position.x + 30 }px;
    `}

    ${ props => props.mode === "dark"
        ? css`background: #191919eb;`
        : css`background: #f3f3f3eb;` }

    ${ props => !props.isDisplayed 
        && css`
            visibility: hidden;
            /* top: -150px; */
        `}
`

const CountryName = styled.div`
    display: flex;
    align-items: center;
    font-weight: bold;
    img {
        margin-right: 8px;
    }
`

export default Preview;